import { render, staticRenderFns } from "./LastOfTheSummerVeg.vue?vue&type=template&id=8680f02c&scoped=true"
import script from "./LastOfTheSummerVeg.vue?vue&type=script&lang=js"
export * from "./LastOfTheSummerVeg.vue?vue&type=script&lang=js"
import style0 from "./LastOfTheSummerVeg.vue?vue&type=style&index=0&id=8680f02c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8680f02c",
  null
  
)

export default component.exports